import { combineReducers } from '@reduxjs/toolkit';

import IdentityReducer from './State/identitySlice';
import UserReducer from './State/userSlice';
import ExportReducer from './State/exportSlice';
import ClientReducer from './State/clientSlice';
import CommonReducer from './State/commonSlice';

const RootReducer = combineReducers({
	client: ClientReducer.client,
	clientInsurance: ClientReducer.clientInsurance,
	skillArea: ClientReducer.skillArea,
	userClient: ClientReducer.userClient,
	clientProgram: ClientReducer.clientProgram,
	calendar: ClientReducer.calendar,
	calendarHelper: ClientReducer.calendarHelper,
	programTarget: ClientReducer.programTarget,
	dataCollection: ClientReducer.dataCollaction,
	behaviorReduction: ClientReducer.behaviorReduction,
	graph: ClientReducer.graph,
	graphAnnotation: ClientReducer.graphAnnotation,
	soapNote: ClientReducer.soapNote,
	billing: ClientReducer.billing,
	session: ClientReducer.session,
	dashboard: ClientReducer.dashboard,
	excelReport: ClientReducer.excelReport,
	authorization: ClientReducer.authorization,
	branch: ClientReducer.branch,
	account: IdentityReducer.account,
	role: IdentityReducer.role,
	identityUser: IdentityReducer.user,
	export: ExportReducer,
	user: UserReducer.user,
	userAuthorization: UserReducer.authorization,
	userBranch: UserReducer.branch,
	clinicalSupervisor: UserReducer.clinicalSupervisor,
	insuranceUser: UserReducer.insurance,
	insurance: ClientReducer.insurance,
	userSessionAllocation: UserReducer.userSessionAllocation,
	common: CommonReducer,
});

export default RootReducer;
